<template>
  <div class="mission">
    <div class="mission-content">
      <div class="mission-h ">
        <div class="fw7 mt50" v-html="$t('referralTips1')"></div>
      </div>
      <div class="referral-list">
        <div class="mission-ul">
          <div class="mission-t mt50" style="font-size:0.42rem;font-weight: 700;">
            {{ $t('Invitation_Link') }}
          </div>
          <div class="referral-c ">
            <div class="ac">
              <div class="fen dib app-en" style="width:80%">
                <input class="input" v-model="info.invite_url" style="font-size: 0.28rem;width: 100%;" readonly>
                <span style="font-size: 0.2rem">{{ $t('Invitation_Count') }}:{{ info.invite_count }}</span>
              </div>
            </div>
            <div class="ac">
              <div class="" style="">
                <div class="btn" id="copycode" style="padding:0.1rem 0.2rem;width:60%;margin:0 auto"
                     :data-clipboard-text="info.invite_url" @click="copy(info.invite_url)">
                  {{ $t('Copy') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="share-panel mt30">
        <div class="share-panel-title">{{ $t('sharePanelTitle') }}</div>
        <div class="share-panel-tips">{{ $t('sharePanelTips') }}</div>
        <div class="share-grid mt20">
          <button
            v-for="item in sharePlatforms"
            :key="item.type"
            class="share-card"
            @click="shareTo(item.type)"
          >
            <span class="share-icon"><img :src="getShareIconSrc(item.type)" :alt="item.labelKey"></span>
            <span class="share-label">{{ item.labelKey }}</span>
          </button>
        </div>
        <div class="share-actions-row mt20">
          <button class="share-more-button" v-if="canUseNativeShare" @click="shareTo('native')">
            <span class="share-more-icon">+</span>
            <span>{{ $t('shareMore') }}</span>
          </button>
        </div>
      </div>
    </div>
    <Dialog ref="alertDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true"
            style="min-height: 3rem;">
      <div class="alert-modal" slot="mdBox">
        <div class="login-c ac">
          <div class="ac"
               style="font-size:0.38rem;margin:0.2rem auto 0.15rem;color:#c20b0b;text-transform: uppercase;padding-top:0.4rem;"
               v-html="$t('congratulations')"></div>
          <div class="ac" style="color:#001d80;margin:0 auto 0.1rem;font-size:34px;" v-html="invitedAlert"></div>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import Header from '../components/header'
import Clipboard from 'clipboard';
import Dialog from '../components/dialog'

export default {
  components: {
    Header, Dialog
  },
  data() {

    return {
      info: {},
      invited_code: '',
      invitedAlert: '',
      allPlatforms: [
        {type: 'whatsapp', labelKey: 'Whatsapp'},
        {type: 'telegram', labelKey: 'Telegram'},
        {type: 'line', labelKey: 'LINE'},
        {type: 'messenger', labelKey: 'Messenger'},
        {type: 'viber', labelKey: 'Viber'},
      ]
    }
  },
  watch: {},
  computed: {
    canUseNativeShare() {
      return !!navigator.share;
    },
    iosOnlyPlatforms() {
      return [{type: 'whatsapp', labelKey: 'Whatsapp'}];
    },
    sharePlatforms() {
      var ua = navigator.userAgent || '';
      var isIOS = /iphone|ipad|ipod/i.test(ua);
      if (isIOS) {
        return this.iosOnlyPlatforms;
      }
      return this.allPlatforms;
    },
  },
  mounted() {
    let that = this;
  },
  created() {
    this.getHome();
  },
  methods: {
    back() {
      this.$router.push({path: '/'})
    },
    getHome() {
      let that = this;
      that.$api.get('/api/user/info', null, r => {
        that.$parent.$parent.returnCode(r, function () {
          that.info = r.data
        });

      })
    },
    copy(item) {
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$utils.alertText(this.$t('CopySucceeded'));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        //console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    getShareIconSrc(type) {
      return 'static/images/logo/' + type + '.png';
    },
    isAndroidDevice() {
      return /android/i.test(navigator.userAgent || '');
    },
    getShareTarget(type) {
      const url = this.info.invite_url;
      const text = this.$t('referralTips1').replace(/<[^>]*>/g, '');
      const encodedUrl = encodeURIComponent(url);
      const encodedText = encodeURIComponent(text);
      const encodedMessage = encodeURIComponent(text + '\n' + url);
      const targets = {
        whatsapp: {
          intentUrl: 'intent://send/?text=' + encodedMessage + '#Intent;scheme=whatsapp;package=com.whatsapp;end',
          schemeUrl: 'whatsapp://send?text=' + encodedMessage,
          webUrl: 'https://wa.me/?text=' + encodedMessage,
        },
        telegram: {
          intentUrl: 'intent://msg_url?url=' + encodedUrl + '&text=' + encodedText + '#Intent;scheme=tg;package=org.telegram.messenger;end',
          schemeUrl: 'tg://msg_url?url=' + encodedUrl + '&text=' + encodedText,
          webUrl: 'https://t.me/share/url?url=' + encodedUrl + '&text=' + encodedText,
        },
        line: {
          intentUrl: 'intent://msg/text/' + encodedMessage + '#Intent;scheme=line;package=jp.naver.line.android;end',
          schemeUrl: 'line://msg/text/' + encodedMessage,
          webUrl: 'https://social-plugins.line.me/lineit/share?url=' + encodedUrl,
        },
        messenger: {
          intentUrl: 'intent://share?link=' + encodedUrl + '#Intent;scheme=fb-messenger;package=com.facebook.orca;end',
          schemeUrl: 'fb-messenger://share?link=' + encodedUrl,
          webUrl: 'https://www.facebook.com/dialog/send?link=' + encodedUrl + '&app_id=291494419107518&redirect_uri=' + encodedUrl,
        },
        viber: {
          intentUrl: 'intent://forward?text=' + encodedMessage + '#Intent;scheme=viber;package=com.viber.voip;end',
          schemeUrl: 'viber://forward?text=' + encodedMessage,
          webUrl: 'viber://forward?text=' + encodedMessage,
        },
      };
      return targets[type] || {};
    },
    openShareLink(url) {
      var popup = window.open(url, '_blank', 'noopener=yes,noreferrer=yes');
      if (popup) {
        popup.opener = null;
      } else {
        window.location.href = url;
      }
    },
    launchWithFallback(intentUrl, schemeUrl) {
      var hidden = false;
      var resolved = false;
      var that = this;
      var cleanup = function () {
        document.removeEventListener('visibilitychange', onVisibilityChange);
        window.removeEventListener('pagehide', onPageHide);
      };
      var finish = function (result) {
        if (resolved) return;
        resolved = true;
        cleanup();
        return result;
      };
      var onVisibilityChange = function () {
        if (document.hidden) {
          hidden = true;
          finish(true);
        }
      };
      var onPageHide = function () {
        hidden = true;
        finish(true);
      };
      document.addEventListener('visibilitychange', onVisibilityChange);
      window.addEventListener('pagehide', onPageHide);
      if (intentUrl && schemeUrl) {
        window.location.href = intentUrl;
        setTimeout(function () {
          if (!hidden) {
            window.location.href = schemeUrl;
          }
        }, 250);
      } else if (intentUrl) {
        window.location.href = intentUrl;
      } else if (schemeUrl) {
        window.location.href = schemeUrl;
      }
      setTimeout(function () {
        if (!hidden) {
          finish(false);
        }
      }, 1400);
    },
    shareTo(type) {
      if (!this.info.invite_url) {
        this.$utils.alertText(this.$t('CopySucceeded'));
        return;
      }
      if (type === 'native') {
        if (navigator.share) {
          navigator.share({
            title: document.title,
            text: this.$t('referralTips1').replace(/<[^>]*>/g, ''),
            url: this.info.invite_url,
          });
        }
        return;
      }
      var target = this.getShareTarget(type);
      var isAndroid = this.isAndroidDevice();
      if (isAndroid && (target.intentUrl || target.schemeUrl)) {
        this.launchWithFallback(target.intentUrl, target.schemeUrl);
        return;
      }
      if (target.webUrl) {
        this.openShareLink(target.webUrl);
      }
    },
  }
}
</script>
<style scoped>
.share-panel {
  background: #fff;
  border-radius: 0.2083rem;
  padding: 0.4167rem 0.3125rem;
  margin: 0 0.3125rem;
  box-shadow: 0 0.0417rem 0.2083rem rgba(13, 14, 49, 0.08);
}

.share-panel-title {
  font-size: 0.375rem;
  font-weight: 700;
  color: #0d0e31;
  text-align: center;
  margin-bottom: 0.1042rem;
}

.share-panel-tips {
  font-size: 0.2292rem;
  color: #666;
  text-align: center;
  margin-bottom: 0.1042rem;
}

.share-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(2.2917rem, 1fr));
  gap: 0.2083rem;
  justify-content: center;
}

.share-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.1042rem;
  width: 100%;
  min-height: 1.4063rem;
  padding: 0.2604rem 0.1563rem;
  border-radius: 0.1563rem;
  background: #f7f8fa;
  border: 0.0104rem solid #eee;
  cursor: pointer;
  transition: all 0.2s;
  color: #203366;
}

.share-card:last-child:nth-child(odd) {
  grid-column: 1 / -1;
  width: calc(50% - 0.1042rem);
  justify-self: center;
}

.share-card:only-child {
  grid-column: 1 / -1;
  width: 2.0833rem;
  justify-self: center;
}

.share-card:active {
  transform: scale(0.96);
  background: #eef0f4;
}

.share-icon {
  width: 0.625rem;
  height: 0.625rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 0.625rem;
}

.share-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.share-label {
  font-size: 0.25rem;
  font-weight: 600;
  white-space: nowrap;
  line-height: 1.1;
}

.share-actions-row {
  display: flex;
  justify-content: center;
  margin-top: 0.2083rem;
}

.share-more-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.0833rem;
  width: 100%;
  padding: 0.2083rem;
  border-radius: 0.1563rem;
  background: #f7f8fa;
  border: 0.0104rem dashed #ccc;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 0.25rem;
  color: #666;
}

.share-more-button:active {
  background: #eef0f4;
  transform: scale(0.98);
}

.share-more-icon {
  font-size: 0.3125rem;
  font-weight: 700;
  color: #0d0e31;
}
</style>



// WEBPACK FOOTER //
// src/page/referral.vue